/* eslint-disable object-property-newline */
import React from 'react';
import { Blueprint, Relationship, MapUtil as Util } from '@leverege/molten/imagine';
import { GoogleGeoShapeRenderer } from '@leverege/molten/data-viewers';
import FilterableZoneGeoShapeModel from "./FilterableZoneGeoShapeModel.js";
import FilterableZoneLoadDataRenderer from "./FilterableZoneLoadDataRenderer.js";
const create = ({
  blueprint,
  layerKey,
  layer
}) => {
  const {
    type: bType
  } = blueprint;
  const {
    path,
    objectType,
    dataPath,
    fallbackDataPath: fallback,
    attributePath,
    relationshipPath,
    sort,
    name
  } = layer;
  const model = FilterableZoneGeoShapeModel;
  const renderer = GoogleGeoShapeRenderer;
  const layerName = `recovr.${bType}:${layerKey}`;
  const id = `blueprint.${layerName}.google.FilterableZoneMapLayer`;
  const bp = Blueprint.getByType(objectType);
  const attribute = bp.getAttribute(attributePath);
  let relationship = Relationship.getByPath(relationshipPath);
  return {
    id,
    sort,
    layerName,
    matches: {
      client: 'GoogleMapsDataViewer',
      path,
      objectType: bType
    },
    createModel: Util.newModelCreator(model, {
      name: `${name} with Filters`,
      objectType,
      layerName
    }),
    create(props) {
      const {
        delegate,
        match
      } = props;
      relationship = relationship ? relationship.createResolved(match) : relationship;
      const pActions = delegate.parent();
      const url = `${pActions.getInterfaceUrl()}/${dataPath.join('/')}`;
      const altUrl = fallback ? `${pActions.getInterfaceUrl()}/${Array.isArray(fallback) ? fallback.join('/') : fallback}` : null;
      const childActions = pActions.child(relationship.attribute.path);
      if (!dataPath && !childActions) {
        // eslint-disable-next-line no-console
        console.warn('Expected to find relationship attribute on parent item', `Actions ID: ${pActions.id}`, relationship);
        return null;
      }
      return /*#__PURE__*/React.createElement(FilterableZoneLoadDataRenderer, {
        ...props,
        childPath: url,
        fallbackChildPath: altUrl,
        renderer,
        delegate: childActions || pActions,
        key: layerName,
        relationship,
        attributeName: `${objectType}.${attributePath}`,
        layerId: `grp-${relationship.path}:${relationship.attributeName}`,
        attribute
      });
    }
  };
};
export default {
  create
};